import { PlatformProviders } from "@ecliptica/game-ui";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { i18n } from "./i18n";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PlatformProviders i18n={i18n} cardsUrl={import.meta.env.VITE_CARDS_URL ?? (import.meta.env.DEV ? "http://localhost:5180/cards" : "/cards")}>
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </PlatformProviders>
  </StrictMode>,
);
